import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const baseURL =
  process.env.VUE_APP_PSYCHOLOGY_RESILIENCE_URL ||
  (process.env.VUE_APP_PSYCHOLOGY_URL
    ? process.env.VUE_APP_PSYCHOLOGY_URL.replace('/api/v1', '/resilience/v1')
    : undefined);

const psychologyResilienceClient = axios.create({
  baseURL,
  withCredentials: true,
});

psychologyResilienceClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(psychologyResilienceClient);

export default psychologyResilienceClient;

